import { useContext } from "react";

import { ApiFormGroup, isDFGroupApi } from "config";
import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { useApiArgument } from "modules";
import { groupDetailMutationBody } from "store/actions/flow";

import { reduce } from "lodash-es";

export const useGroupApi = () => {
  const getArgumentSource = useApiArgument();
  const { dynamicForm } = useContext(DynamicFormContext);
  const dynamicFormApiGroups = dynamicForm.groups?.filter(isDFGroupApi) || [];

  // Return form input values mapped to GroupDetailApi.mutationVariables
  const mapValueToMutationVariable = (
    mutationVariables: ApiFormGroup["detail"]["mutationVariables"]
  ) => {
    const inputMappingWithFormValues = reduce(
      mutationVariables,
      (inputPayload, mutationVariable) => {
        const { name } = mutationVariable;
        const payloadValue = getArgumentSource(mutationVariable);

        return { ...inputPayload, ...(payloadValue !== null && { [name]: payloadValue }) };
      },
      {}
    );

    return inputMappingWithFormValues;
  };

  // Return mutationBody query wrapped in AsyncThunk function
  const createGroupApiThunk = (key: ApiFormGroup["detail"]["key"], input = {}) => {
    const foundApiGroup = dynamicFormApiGroups.find(groupDetail => groupDetail.detail.key === key);

    if (!foundApiGroup) {
      return foundApiGroup;
    }

    const inputPayload = mapValueToMutationVariable(foundApiGroup.detail.mutationVariables);
    const groupMutationThunk = groupDetailMutationBody({
      inputPayload: { ...inputPayload, ...input },
      mutationBody: foundApiGroup.detail.mutationBody,
      mutationKey: key,
    });

    return groupMutationThunk;
  };

  return createGroupApiThunk;
};
